<template>
  <div class="m-anc-wrapper">
    <h3>公告</h3>
    <!-- 时间轴 -->
    <div class="time">
      <div class="timeline">
        <div class="timeline-item" v-for="(year, index) in reversedYears" :key="index">
          <div class="timeline-step" v-bind:class="{ 'focus-step': year && year.value == curTimeLineYear }" @click="timelineClick(year && year.value)">
            <div class="timeline-circle"></div>
            <div class="line" v-if="index < reversedYears.length - 1"></div>
            <div class="timeline-date">{{ year && year.value }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="list-container">
      <div class="list" v-if="announcements && announcements.length > 0">
        <a :href="announcement.noticeUrl" target="_blank" v-for="announcement in announcements" :key="announcement.id">
          <div class="item">
            <img class="left-icon" src="https://img.i2soft.net/i2official-web/v2/assets/images/relations/phone/anc_icon.svg" />
            <div class="right-box">
              <div>{{ announcement.noticeDayStr }}</div>
              <div class="desc">{{ announcement.title }}</div>
            </div>
          </div>
        </a>
      </div>
      <el-empty v-else description="暂无数据" />
    </div>
    <!-- 分页-->
    <div class="pagination">
      <el-pagination background @current-change="handleCurrentChange" :current-page="page.currentPage" :page-size="page.pageSize" layout="prev, pager, next" :total="page.total" size="small"> </el-pagination>
    </div>
  </div>
</template>

<script>
  import { useGetAnnouncementListApi } from "@/api/useAnnonceApi";

  export default {
    name: "AnnounceComp",
    props: {},
    data() {
      return {
        years: [],
        curTimeLineYear: "", // 当前时间轴所选年份
        //分页
        page: {
          currentPage: 1,
          pageSize: 10,
          total: 0,
        },
        // 显示的数据
        announcements: [],
      };
    },
    filters: {
      // 年月过滤
      filter_month(value) {
        return value.substring(0, 7);
      },
      // 日期过滤
      filter_date(value) {
        return value.substring(8, 10);
      },
    },
    created() {
      this.initYears();
      this.curTimeLineYear = this.years[0].value; // 默认选中最新年份
      this.getData();
      window.scrollTo(0, 540);
    },
    mounted() {
      window.addEventListener("scroll", this.getScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.getScroll);
    },
    computed: {
      reversedYears() {
        return this.years.slice();
      },
    },
    methods: {
      // 初始化年份数据，从当前年份到2018年
      initYears() {
        const currentYear = new Date().getFullYear();
        this.years = [];
        for (let year = currentYear; year >= 2018; year--) {
          this.years.push({
            value: year.toString(),
            label: `${year}年`,
          });
        }
      },

      // 点击时间轴时间点
      async timelineClick(cur) {
        this.curTimeLineYear = cur;
        // 切换年份时重置页码为第一页
        this.page.currentPage = 1;
        await this.getData();
      },

      //获取数据并处理
      async getData() {
        try {
          const res = await useGetAnnouncementListApi({
            pageNum: this.page.currentPage,
            pageSize: this.page.pageSize,
            year: this.curTimeLineYear,
          });

          if (res) {
            // 获取返回的数据
            this.announcements = res.records || [];
            // 设置分页信息
            this.page.total = res.total || 0;
            this.page.currentPage = res.current || 1;
          }
        } catch (error) {
          console.error("获取公告数据失败:", error);
          this.announcements = [];
          this.page.total = 0;
        }
      },

      // 分页
      async handleCurrentChange(newPage) {
        this.page.currentPage = newPage;
        await this.getData();
      },

      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (!!document.documentElement.scrollTop && document.documentElement.scrollTop >= 70) {
          this.$store.commit("TO_AfterScroll");
        } else {
          this.$store.commit("TO_AfterScroll_false");
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  * {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .m-anc-wrapper {
    padding: 12px;

    .time {
      padding-top: 20px;
      margin-bottom: 10px;

      .timeline {
        display: flex;
        flex-direction: row;
        align-items: center;

        .timeline-item {
          position: relative;
          padding: 20px 0;
          width: 100%;

          .timeline-step {
            position: relative;
            text-align: center;
            cursor: pointer;

            .timeline-circle {
              width: 8px;
              height: 8px;
              background-color: #d8d9db;
              border-radius: 50%;
              margin: 0 auto;
              position: relative;
              z-index: 1;
            }

            .timeline-date {
              margin-top: 16px;
              font-size: 14px;
              color: #999999;
            }
          }

          .focus-step {
            .timeline-circle {
              background-color: #b08d57;
            }

            .timeline-date {
              color: #b08d57;
              font-weight: bold;
            }
          }

          .line {
            position: absolute;
            left: 50%;
            top: 3px;
            width: calc(100%);
            height: 2px;
            background: #d8d9db;
          }
        }
      }
    }
    .list-container {
      .list {
        display: flex;
        flex-direction: column;
        row-gap: 10px;

        a {
          text-decoration: none;
          background: #f8f8f8;
        }

        .item {
          padding: 16px 12px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          column-gap: 15px;
          .left-icon {
            width: 36px;
            min-width: 36px;
            height: 36px;
          }

          .right-box {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-around;

            div {
              font-size: 12px;
              font-weight: normal;
              line-height: 14px;
              letter-spacing: 0.9px;
              color: #999999;
            }

            .desc {
              margin-top: 4px;
              text-align: left;
              font-weight: bold;
              color: #333333;
            }
          }
        }
      }
    }

    .pagination {
      width: 100%;
      padding: 30px 0px;
      overflow: hidden;
      display: flex;
      justify-content: center;
    }
  }

  /deep/ .el-pagination {
    padding: 0px;
    width: 100%;
  }
  /deep/.el-pagination.is-background .el-pager li {
    min-width: 25px;
    margin: 0 3px;
  }
  /deep/ .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    min-width: 25px;
    margin: 0 3px;
  }
  /deep/ .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    min-width: 25px;
    margin: 0 3px;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #b08d57;
    color: #fff;
  }
</style>
